import React from 'react';
import CustomModal from '../../../../../components/CustomModal';
import { IOperacaoPatioSPE } from '../types/types';
import Form from './Form';

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  onClear: () => void;
  onConfirm: () => void;
  selectedRow?: IOperacaoPatioSPE;
}

const Create: React.FC<Props> = (props: Props) => {
  return (
    <CustomModal title={props.isEdit ? "Editar Associação Triagens SPE" : "Associar Entrada e Agendamento SPE"} onClose={props.onClear}>
      <Form
        isView={props.isView}
        selectedRow={props.selectedRow}
        onConfirm={props.onConfirm}
        isEdit={props.isEdit}
        onClose={props.onClear}
      />
    </CustomModal>
  );
};

export default Create;
